//export const serverUrl = "https://us-central1-brainium-firebase-test.cloudfunctions.net/app";
export const serverUrl = "https://us-central1-brainium-qa.cloudfunctions.net/app";